import React, { useEffect, useState } from "react";
import {
  AddContactIcon,
  DateRangeIcon,
  FilterIcon,
  QuickActionBtnIcon,
} from "../common/Icon";
import FilterModel from "./FilterModel";
import { useStateProvider } from "../common/StateProvider";
import NewContactsItem from "./NewContactsItem";
import FollowUpsItem from "./FollowUpsItem";
import MeetingItem from "./MeetingItem";
import ReconnectsItem from "./ReconnectsItem";

const TodayWorkflow = () => {
  const [filterModel, setFilterModel] = useState(false);
  // GET THE ACTIVE AND SETACTIVE TAB  FROM PROVIDER
  const { activeTab, setActiveTab } = useStateProvider();

  // Function to show the Productivity modal
  const openProductivityModal = () => {
    setFilterModel(true);
  };

  // Function to close the Productivity modal
  const closeProductivityModal = () => {
    setFilterModel(false);
  };

  // const currentDate = new Date();
  // // Get current year, month, and date
  // const year = currentDate.getFullYear();
  // const month = currentDate.getMonth() + 1;
  // const date = currentDate.getDate();
  // const fullDate =
  //   date.toString() + "-" + month.toString() + "-" + year.toString();

  // OVERLAY BEHIND FILTER MODEL
  const overLayHidden = () => {
    setFilterModel(!filterModel);
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (filterModel) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [filterModel]);

  return (
    <>
      <div className="bg-white shadow-todays_workflow_box_shadow rounded-xl border border-solid border-[rgba(111,_106,_248,_0.10)] px-3 py-5 md:p-[30px_20px_13px_20px] mt-4 mx-2 xs:mx-5 mb-4 3xl:mb-0">
        <div className=" flex flex-col sm:flex-row items-center justify-between">
          <div>
            <h5 className="text-sm 3xl:text-[16px] font-bold text-black text-center sm:text-start">
              Todays Workflow
            </h5>
            <div className=" flex items-center gap-2 pt-1">
              <p className="text-xs 3xl:text-[14px] font-normal text-black opacity-70">
                Selecting the contact and create productive task
              </p>
              <div className="gap-1 items-center hidden sm:flex ">
                <span>
                  <DateRangeIcon />
                </span>
                <span className="text-[10px] 3xl:text-[14px] font-normal text-gray">
                  09/11/22
                </span>
              </div>
            </div>
          </div>
          <div className=" flex items-center gap-5 relative pt-4 md:pt-0 ">
            <div className=" gap-1 items-center sm:hidden flex ">
              <span>
                <DateRangeIcon />
              </span>
              <span className="text-[10px] 3xl:text-[14px] font-normal text-gray">
                09/11/22
              </span>
            </div>
            <button
              onClick={openProductivityModal}
              className="outline-none filter-btn hover:bg-primary rounded-full duration-200">
              <FilterIcon />
            </button>
            <div className="absolute top-14 end-14 z-[60]  !opacity-100">
              {filterModel && (
                <FilterModel
                  filterModel={filterModel}
                  setFilterModel={closeProductivityModal}
                />
              )}
            </div>

            <button className="text-sm font-medium text-primary p-2.5 rounded-[36px] border border-solid border-primary flex items-center gap-2.5 hover:bg-primary hover:text-white workflow-add-contact-btn duration-200">
              <span>
                <AddContactIcon />
              </span>
              Add Contact
            </button>
          </div>
        </div>
        <div>
          <div className=" overflow-x-auto overflow_x_scroll_style mb-2">
            <div className=" flex gap-2 pt-5 w-max sm:w-auto pb-2">
              <button
                onClick={() => setActiveTab("newContacts")}
                className={`text-xs 3xl:text-[14px] font-normal text-black opacity-70 p-[8px_16px] rounded bg-[rgba(111,_106,_248,_0.10)] hover:bg-primary hover:text-white hover:opacity-100 duration-300 ${
                  activeTab === "newContacts"
                    ? " !bg-primary !text-white !opacity-100"
                    : ""
                } `}>
                New Contacts
              </button>

              <button
                onClick={() => setActiveTab("followUps")}
                className={`text-xs 3xl:text-[14px] font-normal text-black opacity-70 p-[8px_16px] rounded bg-[rgba(111,_106,_248,_0.10)] hover:bg-primary hover:text-white hover:opacity-100 duration-300 ${
                  activeTab === "followUps"
                    ? " !bg-primary !text-white !opacity-100"
                    : ""
                } `}>
                Follow Ups
              </button>
              <button
                onClick={() => setActiveTab("meeting")}
                className={`text-xs 3xl:text-[14px] font-normal text-black opacity-70 p-[8px_16px] rounded bg-[rgba(111,_106,_248,_0.10)] hover:bg-primary hover:text-white hover:opacity-100 duration-300 ${
                  activeTab === "meeting"
                    ? " !bg-primary !text-white !opacity-100"
                    : ""
                } `}>
                Meeting
              </button>
              <button
                onClick={() => setActiveTab("reconnects")}
                className={`text-xs 3xl:text-[14px] font-normal text-black opacity-70 p-[8px_16px] rounded bg-[rgba(111,_106,_248,_0.10)] hover:bg-primary hover:text-white hover:opacity-100 duration-300 ${
                  activeTab === "reconnects"
                    ? " !bg-primary !text-white !opacity-100"
                    : ""
                } `}>
                Reconnects
              </button>
            </div>
          </div>
          <div className="lg:overflow-y-auto h-full  lg:h-[calc(100vh-511px)] overflow-x-auto overflow_x_scroll_style pe-2 ">
            {activeTab === "newContacts" && <NewContactsItem />}
            {activeTab === "followUps" && <FollowUpsItem />}
            {activeTab === "meeting" && <MeetingItem />}
            {activeTab === "reconnects" && <ReconnectsItem />}
          </div>
        </div>
      </div>
      <div
        onClick={overLayHidden}
        className={` fixed inset-0 min-h-full z-50  bg-black opacity-10 ${
          filterModel ? "w-[100%] " : "hidden"
        }`}></div>
    </>
  );
};

export default TodayWorkflow;
